import React from 'react';
import { useState, useEffect } from 'react';
import Banner from './Banner';
import "./home.scss"
import OurStories from './OurStories';
import meta_tags from '../../Data/MetaTags';
import {
  useLocation,
} from 'react-router-dom';
import FooterCtaSection from '../Common-features/FooterCtaSection';
import HomePageData from './home-data';
import SolutionsUnleashed from './SolutionsUnleashed';
import OurServices from './OurServices';
import OurProducts from './OurProducts';

function Body() {

  const [rendercount, setRenderCount] = useState(() => false);

  const location = useLocation();


  useEffect(() => {
    setRenderCount(true)
    if (rendercount === true) {
      document.title = meta_tags["https://choicetechlab.com/"] ? meta_tags["https://choicetechlab.com/"].title : '';
      document.getElementById('meta-tags').content = meta_tags["https://choicetechlab.com/"] ? meta_tags["https://choicetechlab.com/"].content : '';
      document.getElementById('canonical-link').href = meta_tags["https://choicetechlab.com/"] ? meta_tags["https://choicetechlab.com/"].link : '';
  if(!(document.getElementById('link1')==null)){ 
  document.getElementById('link1').remove();
  document.getElementById('link2').remove();
  document.getElementById('link3').remove();
  document.getElementById('link4').remove();
  document.getElementById('link5').remove();
  document.getElementById('link6').remove();
  
  }
}
  }, [rendercount])


  return (
    <div className='home-page'>
        <Banner/>
        <OurProducts />
        <SolutionsUnleashed />
        <OurServices />
        <OurStories />
        <FooterCtaSection data={HomePageData.FooterCtaSection} />
    </div>
  )
}

export default Body;
